import { getComponentCssUrl, getGlobalCssUrl } from '../Global/loadDependency'

function createNavHeaderLevel2Template() {
  const t = document.createElement('template')
  t.innerHTML =`
  <link href="${getGlobalCssUrl('trustage-aa--wc.css')}" rel="stylesheet" />
  <link href="${getComponentCssUrl('NavHeader-Level2--wc.css')}" rel="stylesheet" />
  `
  return t;
}

const getTemplateNavHeaderStyles = () => createNavHeaderLevel2Template();
export { getTemplateNavHeaderStyles };
